export default "__VITE_ASSET__CH2Izc1Q__"